import { useState } from "react";
import { statusOf } from "../lib/api-error.ts";
import { api } from "../lib/api.ts";
import { RAW_ANSWER_BUTTON, RAW_ANSWER_NOTE, rawAnswerText } from "../lib/raw-answer.ts";
import { readFailure } from "../lib/read-failure.ts";
import { Button, InfoBanner } from "../ui/index.ts";

type Raw =
	| { state: "idle" }
	| { state: "loading" }
	| { state: "failed"; why: string; status: number | null }
	| { state: "ready"; text: string };

/** X's `data` for one promoted tweet, read on request and shown as text (lib/raw-answer.ts). */
export function RawAnswer({ id, account }: { id: string; account: string }) {
	const [raw, setRaw] = useState<Raw>({ state: "idle" });

	const show = async () => {
		setRaw({ state: "loading" });
		try {
			const body = await api.promotedTweetRaw(id, account);
			setRaw({ state: "ready", text: rawAnswerText(body.raw) });
		} catch (e) {
			setRaw({
				state: "failed",
				why: e instanceof Error ? e.message : String(e),
				status: statusOf(e),
			});
		}
	};

	if (raw.state === "ready")
		return (
			<div className="mt-2">
				<p className="text-xs text-muted">{RAW_ANSWER_NOTE}</p>
				<pre className="mt-1 max-h-80 overflow-auto rounded bg-surface-2 p-2 font-mono text-xs text-content">
					{raw.text}
				</pre>
			</div>
		);
	return (
		<div className="mt-2">
			<Button
				type="button"
				variant="outline"
				size="sm"
				disabled={raw.state === "loading"}
				onClick={() => {
					void show();
				}}
			>
				{RAW_ANSWER_BUTTON}
			</Button>
			{raw.state === "failed" &&
				(() => {
					const f = readFailure(raw.status, {
						what: "X's data for this ad",
						forbidden: "This sign-in may not read this account.",
					});
					return (
						<InfoBanner variant={f.variant} title={f.title}>
							{raw.why}
						</InfoBanner>
					);
				})()}
		</div>
	);
}
